import React from 'react';
import { Box } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/supabase/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AuthPage from './components/auth/AuthPage';
import Dashboard from './pages/Dashboard';
import RDV from './pages/RDV';
import CRM from './pages/CRM';
import MesCampagnes from './pages/MesCampagnes';
import { CampagneDetails } from './pages/CampagneDetails';
import MonCompte from './pages/MonCompte';
import { AdminDashboard } from './pages/AdminDashboard';
import { CallerDashboard } from './pages/CallerDashboard';
import AppLayout from './components/AppLayout';
import RoleBasedRoute from './components/auth/RoleBasedRoute';

function App() {
  return (
    <AuthProvider>
    <Router>
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
          <Routes>
            {/* Routes publiques */}
            <Route path="/auth" element={<AuthPage />} />

            {/* Routes protégées */}
            <Route element={<ProtectedRoute />}>
              <Route element={<AppLayout />}>
                {/* Routes standard pour tous les utilisateurs connectés */}
                <Route path="/" element={<Dashboard />} />
                <Route path="/rdv" element={<RDV />} />
                <Route path="/crm" element={<CRM />} />
                <Route path="/campagnes" element={<MesCampagnes />} />
                <Route path="/campagne/:id" element={<CampagneDetails />} />
                <Route path="/mon-compte" element={<MonCompte />} />
                
                {/* Routes spécifiques aux rôles */}
                <Route element={<RoleBasedRoute requiredRole="admin" />}>
                  <Route path="/admin" element={<AdminDashboard />} />
                </Route>
                
                <Route element={<RoleBasedRoute requiredRole="caller" />}>
                  <Route path="/caller" element={<CallerDashboard />} />
                </Route>
              </Route>
            </Route>

            {/* Redirection par défaut */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
      </Box>
    </Router>
    </AuthProvider>
  );
}

export default App; 